<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'lf-base-video',
})
</script>
<!--
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-06-20 15:06:32
 * @LastEditors: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @LastEditTime: 2025-03-31 14:57:38
 * @FilePath: /qd-yunjing-web/src/components/lf-base-video/src/index.vue
 * @Description: 这是默认设置,请设置`customMade`,
-->
<template>
  <div
    :id="'playVideo'+id"
    class="play-video"
  >
  </div>
</template>

<script lang="ts" setup name='lf-base-video'>
  import {
    ref, onMounted, onBeforeUnmount, reactive, defineProps, defineExpose,
    watch,
  } from 'vue';
  import servers from '@/api/servers';
  import {
    getCameraTokenRequest,
  } from '@/api/modules/device';
  import { LocalStorageService } from '@/utils/storage';

  const {
    DEV: isDev,
    VITE_APP_BASE_API: baseApi,
    VITE_APP_GAIA_API_KEY: apiKey,
  } = import.meta.env;
  // 查看视频
  const APP_ID = 'qd-insight';
  const emit = defineEmits(['playback']);

  const props = defineProps({
    cameraId: {
      required: true,
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
  });
  const player = ref(null as any);
  const options = reactive({
    headerKey: 'tenantId',
    headerValue: LocalStorageService.get('_current_tenant')?.mid || '',
    autoplay: true,
    // video宽度
    width: '100%',
    // video高度
    height: '100%',
    // 摄像头ID
    cameraId: '',
    /*
     * 码流：主码流0 子码流1
     * channel: 1,
     * 是否需要控制条，默认需要
     */
    controls: true,
    // 视频播放时长（单位s），默认300s  60 * 60 * 2
    duration: 60,
    // 视频编码格式，可选值：vp8、h264 vp9表示h265
    encoding: 'vp9',
    // 是否全屏，默认不全屏
    fullscreen: false,
    // websocket最大重连次数
    maxReConnect: 20,
    // 是否静音，默认静音
    muted: true,
    projectId: '',
    // 音量，范围 0~1
    volume: 1,
    env: 'uat',
    watermark: ' ',
    videoLayoutType: 'contain',
    videoOverTime: 30,
    command: 'playReq',
    poster: '',
    appid: APP_ID,
    apptoken: '',
    webGlurl: `${location.protocol}//${location.hostname}:${location.port}`,
    ptzAbility: true,
    accessChannel: '云境',
    isHuiyan: 0,
    Authorization: '',
    // baseUrl: `${baseApi}${servers.qdInsight}`,
    baseUrl: isDev ? servers.qdInsight : `${baseApi}${servers.qdInsight}`,
    gaiaKey: apiKey,
    callbackfn: (isPlaying:boolean) => {
      emit('playback', isPlaying);
    },
    /*
     * pauseBackfn: (isPlaying) => {
     *   console.log('ssss111', isPlaying);
     *   this.playerflag = isPlaying;
     *   this.$emit('callback', false, isPlaying);
     * },
     */

  });
  const destroyPlayer = () => {
    console.log('销毁销毁', player.value);
    if (player.value !== null) {
      player.value.terminal_a();
      player.value.destroy();
      player.value.destroy_a();
      player.value.destroy_b();
      player.value = null;
    }
  };
  const initPlayer = () => {
    const name = LocalStorageService.get('_user_info')?.loginName || ' ';
    options.watermark = name;
    options.projectId = 'projectId';
    options.cameraId = props.cameraId;
    if (player.value) {
      destroyPlayer();
    }
    player.value = new (window as any).Player(`#playVideo${props.id}`, options);
    console.log('player', player.value);
  };

  // 截图方法
  // eslint-disable-next-line consistent-return
  const snapshot = () => {
    const myPlayer = player.value;
    let isPlaying = false;
    if (myPlayer) {
      isPlaying = myPlayer.isPlaying;
    }
    if (isPlaying) {
      let videoEle;
      if (myPlayer.ish265) {
        videoEle = myPlayer.canvasDOM;
        console.log(videoEle.toDataURL('image/jpeg'));
        return videoEle.toDataURL('image/jpeg');
        // }
      } if (myPlayer.videoEle_a || myPlayer.videoEle_b) {
        videoEle = myPlayer.videoEle_a || myPlayer.videoEle_b;
        const canvas = document.createElement('canvas');
        const w = videoEle.videoWidth;
        const h = videoEle.videoHeight;
        canvas.width = w;
        canvas.height = h;
        const canvasCtx = canvas.getContext('2d') as any;
        canvasCtx.drawImage(videoEle, 0, 0, w, h, 0, 0, w, h);
        return canvas.toDataURL('image/jpeg');
      }
    } else {
      return false;
    }
  };
  const getCameraToken = () => {
    if (props.cameraId) {
      // 获取摄像头token
      getCameraTokenRequest({
        appid: APP_ID,
        cid: props.cameraId,
      }).then((res) => {
        console.log('playBackData', res);
        options.apptoken = res.data.token;
        options.Authorization = res.data.token;
        initPlayer();
      });
    }
  };

  onMounted(() => {
    console.log('mounted', props.cameraId);
    getCameraToken();
  });
  watch(() => props.cameraId, () => {
    console.log('watch');
    getCameraToken();
  });
  onBeforeUnmount(() => {
    console.log('unmounted');
    destroyPlayer();
  });

  defineExpose({
    snapshot,
    player,
  });
</script>

<style lang="scss" scoped>
.play-video{
  width: 100%;
  height: 100%;

  :deep(.webrtc-time){
    width: 80px;
  }
}
</style>
